import { render, staticRenderFns } from "./Viajantes.vue?vue&type=template&id=d1441a90&"
import script from "./Viajantes.vue?vue&type=script&lang=js&"
export * from "./Viajantes.vue?vue&type=script&lang=js&"
import style0 from "./Viajantes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports